import React, { useEffect, useState } from "react";
import { Modal, Form, Switch, Button, Select, message, InputNumber } from "antd";
import "./style.scss";
import PosService from "../../services/PosService";
import { useSelector } from "react-redux";

const { Option } = Select;

export default function AssignEmployeeModal({ data,waitlist,servers, ...props }) {
  const formRef = React.createRef();
  const [form] = Form.useForm();
  const [joinTableDisable, setJoinTableDisable] = useState(true);
  const [waitlistDisable, setWaitlistDisable] = useState(true);

  const adminRestaurant = useSelector((state) => state.admin);
  
  const onChange = (checked) => {
  
    setJoinTableDisable(checked);
  };
  const waitlistCheck =(checked)=>{
    setWaitlistDisable(checked)
  }
  const assignSection = async(values)=>{
    console.log(data);
    // values.section_id = data?.selectedSection?.section_id;
    values.host_employee_id = localStorage.getItem("LoginId") && Number( localStorage.getItem("LoginId"))
    values.num_people = Number(values.num_people) || 0;
    if(!waitlistDisable)
    values.waitlist_id = undefined
    if(!joinTableDisable)
    values.table_ids = undefined
    const tabledataRestaurent = await PosService.updateTableMapping(adminRestaurant,values);
    if(tabledataRestaurent.err)
      message.error(tabledataRestaurent?.msg)
    else
    message.success("updated successfully")
    
    props.closeModal(false)
  }
 
  return (
    <Modal
      title={`Table no: ${data?.data?.table_label} (Ocupancy ${data?.data?.text})`}
      open={props.modalOpen}
      footer={null}
      onCancel={() => props.closeModal(false)}
    >
      <Form ref={formRef} form={form} layout="vertical"
        onFinish={assignSection}>
        <Form.Item name="server_employee_id" label="Server Assigned">
          <Select defaultValue={data?.employee_id} >
            {servers &&
              servers.map((item) => (
                <Option value={item.id}>{item.name}</Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item name="num_people" label="Number of Guests">
          <InputNumber style={{width:'100%'}} value={data?.num_people} type="Number"/>
        </Form.Item>
        <div className="join-section">
        <Switch
        className="join-btn"
        onChange={onChange}
        defaultChecked
          // onChange={() => {
          //   setJoinTableDisable(true);
          // }}
          // checked ={joinTableDisable}
        />
        <Form.Item name="table_ids" label="Join Table" rules={[
        {
          required: true,
        },
      ]}>
          <Select
            disabled={!joinTableDisable}
            // defaultValue={data?.joinTable}
            mode="multiple"
             
          >
             {data?.section &&
              data?.section.
              filter(filterItem=> filterItem?.table_number != data?.data?.table_number).
              map((item) => (
                <Option value={item?.id}>{Number(item?.table_number)}</Option>
              ))}
          </Select>
        </Form.Item>
        </div>
        <div className="join-section">
        <Switch
        className="join-btn"
        defaultChecked
          onChange={waitlistCheck}
          // checked ={joinTableDisable}
        />
        <Form.Item name="waitlist_id" label="Select guest from waitlist">
          <Select
            disabled={!waitlistDisable}
            
          >
             {waitlist &&
              waitlist.map((item) => (
                <Option value={item.id}>{item.name}</Option>
              ))}
          </Select>
        </Form.Item>
        </div>

        <Form.Item className="button-form">
          <Button type="primary" htmlType="submit">
            {!data.is_occupied ? "Mark as Occupied" : "View Table Details"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
